import React, {useEffect, useState} from "react";
import DashboardLayout from "../../layouts/Dashboard";
import { useTranslation } from "react-i18next";
import { SearchPanel, TableCustom } from "../../components";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import Box from "@mui/material/Box";
import { Button } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { getResultForms, addResultForm, editResultForm, deleteResultForm, getResultFormByKey } from "../../redux/actions/resultFormActions";
import CreateResultForm from "./Popups/CreateResultForm";
import ResultFormDetails from "./Popups/ResultFormDetails";
import EditResultForm from "./Popups/EditResultForm";
import RemoveResultForm from "./Popups/RemoveResultForm";

function createData(id, number, createdAt, schema, filial) {
    return {id, number, createdAt, schema, filial};
}

let rows = [
    createData(1, "abc", "12.03.2021 00:00", null, null),
];
const ResultFormList = () => {
    const {t} = useTranslation();
    const rowName = [
        {text: t("resultFormList.tableItem.id")},
        {text: t("resultFormList.tableItem.number")},
        {text: t("resultFormList.tableItem.createdAt")},
        {text: t("resultFormList.tableItem.schema")},
        {text: t("resultFormList.tableItem.filial")},
        {text: t("resultFormList.tableItem.actions")},
    ];
    const dispatch = useDispatch();

    const [query, setQuery] = useState({ "sort": { "id": { "operator": "asc" } }, "paging": { take: 200 } });

    const [id, setId] = useState(null);
    const [createOpen, setCreateOpen] = useState(false);
    const setCreateHandler = async () => {
        setCreateOpen(false);
        setDetailsOpen(false);
        setEditOpen(false);
        setRemoveOpen(false);
        setCreateOpen(true);
        setId(null);
    }
    const createSubmit = async (_) => {
        await dispatch(addResultForm(_, query));
    }
    const [detailsOpen, setDetailsOpen] = useState(false);
    const setDetailsHandler = async (id) => {
        await dispatch(getResultFormByKey(id));
        setCreateOpen(false);
        setDetailsOpen(false);
        setEditOpen(false);
        setRemoveOpen(false);
        setDetailsOpen(true);
        setId(id);
    }

    const [editOpen, setEditOpen] = useState(false);
    const setEditHandler = async (id) => {
        await dispatch(getResultFormByKey(id));
        setCreateOpen(false);
        setDetailsOpen(false);
        setEditOpen(false);
        setRemoveOpen(false);
        setEditOpen(true);
        setId(id);
    }
    const editSubmit = async (_) => {
        await dispatch(editResultForm(_, query));
    }
    const [removeOpen, setRemoveOpen] = useState(false);
    const setRemoveHandler = async (id) => {
        await dispatch(getResultFormByKey(id));
        setCreateOpen(false);
        setDetailsOpen(false);
        setEditOpen(false);
        setRemoveOpen(false);
        setRemoveOpen(true);
        setId(id);
    }
    const removeSubmit = async (_) => {
        await dispatch(deleteResultForm(_.id, query));
    }

    const localData = false;
    const state = useSelector((state) => state.resultForm);
    if (!localData && state.resultForms)
    {
        rows = state.resultForms;
    }
    useEffect(() => {
        if (!localData)
        {
            dispatch(getResultForms(query));
        }
    }, [dispatch]);
    return (
        <DashboardLayout>
            <Box sx={{margin: '20px 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                <SearchPanel searchName="id" search={rows} label={t("resultFormList.searchLabel")}/>
                <Button color="primary" variant="contained" onClick={() => setCreateHandler()}>
                    {t("resultFormList.createText")}
                </Button>
            </Box>
            <TableCustom avatars={false} rowName={rowName} rows={rows.map(_ => {
                return {
                    id: _.id,
                    number: _.number,
                    createdAt: _.createdAt,
                    schema: _.schema,
                    filial: _.filial?.name,
                }
            })} actions={(_) => [<VisibilityIcon onClick={() => setDetailsHandler(_.id)}/>,<EditIcon onClick={() => setEditHandler(_.id)}/>,<DeleteForeverIcon onClick={() => setRemoveHandler(_.id)}/>]}/>
            <CreateResultForm action={'create'} title={t("resultFormList.createText")} open={createOpen} setOpen={setCreateOpen} onSubmit={createSubmit}/>
            <ResultFormDetails action={'details'} title={t("resultFormList.detailsText")} open={detailsOpen} setOpen={setDetailsOpen} />
            <EditResultForm action={'edit'} title={t("resultFormList.editText")} open={editOpen} setOpen={setEditOpen} onSubmit={editSubmit}/>
            <RemoveResultForm action={'remove'} title={t("resultFormList.removeText")} open={removeOpen} setOpen={setRemoveOpen} onSubmit={removeSubmit}/>
        </DashboardLayout>
    )
};

export default ResultFormList;
